<template>
  <div class="down-wrap">
    <div class="phone">
      <div class="logo-img">
        <img src="../downPage/logo.png" />
      </div>
      <div class="logo-txt">
        <img src="../downPage/logo-txt.svg" />
      </div>
      <div class="logo-desc">
        <span>
          Get Best Storytellers,<br /> For Best Listeners
        </span>
      </div>
    </div>
    <div class="p-right">
      <div class="desc-t">
        <!-- Scan to download the app -->
        Scan to listen <br />the book
      </div>
      <div class="desc-qr">
        <qrcode-vue :value="downloadUrl" :size="100" class="qrcode-wrap" level="H"></qrcode-vue>
      </div>
      <div class="desc-line">
        <span class="line-txt">OR</span>
      </div>
      <div class="btn-wrap">
        <img @click="clickHandler(1)" src="../downPage/ios.svg" />
        <img @click="clickHandler(2)" src="../downPage/andr.svg" />
      </div>
    </div>
  </div>
</template>

<script>
import QrcodeVue from "qrcode.vue";

export default {
  name: "DownView",
  inject: ['home'],
  components: {
    QrcodeVue,
  },
  data() {
    return {};
  },
  computed: {
    downloadUrl() {
      return this.home.downloadUrl;
    },
  },
  methods: {
    clickHandler(type) {
      if (type === 1) {
        // ios传true，andriod false
        this.$emit("download", true);
      } else {
        this.$emit("download", false);
      }
    },
  },
  mounted() {

  },
};

</script>

<style lang="scss" scoped>
.down-wrap {
  min-width: 800px;
  font-size: 0px;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
  // height: 100%;
  height: 100vh;
  min-height: 608px;
  background-color: #f2f3f5;

  .phone {
    width: 364px;
    height: 608px;
    background-image: url("../downPage/phone-bg.png");
    background-size: cover;
    background-repeat: no-repeat;
    padding-top: 170px;
    box-sizing: border-box;

    .logo-img {
      font-size: 0px;
      box-sizing: border-box;
      padding-left: 112px;
      img {
        width: 100px;
      }
    }
    .logo-txt {
      font-size: 0px;
      margin-top: 12px;
      margin-bottom: 8px;
      box-sizing: border-box;
      padding-left: 112px;
      img {
        width: 100px;
      }
    }
    .logo-desc {
      box-sizing: border-box;
      padding-left: 44px;

      span {
        display: inline-block;
        width: 236px;
        height: 30px;
        font-size: 10px;
        font-family: Poppins-Regular, Poppins;
        font-weight: 400;
        color: #565b65;
        line-height: 16px;
        text-align: center;
      }
    }
  }

  .p-right {
    margin-left: 40px;
    width: 294px;
    height: 608px;
    box-sizing: border-box;
    padding-top: 112px;
    .desc-t {
      width: 294px;
      height: 86px;
      font-size: 32px;
      font-family: Poppins-Bold, Poppins;
      font-weight: bold;
      color: #313641;
      line-height: 43px;
      text-align: center;
    }
    .desc-qr {
      margin: 25px auto 30px auto;
      width: 120px;
      height: 120px;
      background: #ffffff;

      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 8px;

      .qrcode-wrap {
        font-size: 0px;
      }
    }

    .desc-line {
      height: 15px;
      position: relative;
      &::after {
        content: " ";
        display: inline-block;
        position: absolute;
        left: 0px;
        right: 0px;
        top: 8px;
        height: 0.5px;
        background: #d0d4de;
      }

      .line-txt {
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        z-index: 9;
        display: inline-block;
        width: 26px;
        height: 15px;
        font-size: 10px;
        font-family: Poppins-Medium, Poppins;
        font-weight: 500;
        color: #313641;
        line-height: 16px;
        background-color: #f2f3f5;
        text-align: center;
      }
    }

    .btn-wrap {
      margin-top: 20px;
      display: flex;
      justify-content: space-between;
      img {
        cursor: pointer;
      }
    }
  }
}
</style>
